import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from '../../components/g-button/g-button.vue'


const name = 'g-menu-sidebar'
export default {
  name,

  components: { 
    'g-card': gCard,
    'g-form': gForm,
    'g-button' : gButton
  }, 

  props: {
    titulofechado: {
        type: String,
        default: 'Resumo'
      },
    tituloaberto: {
        type: String,
        default: 'Resumo'
    }
   },

  mounted () { },

  updated () { },

  data () {
    return { 
        lateral: false,
    }
  },

  methods: { },

  computed: { }, 

};